module.exports = __webpack_public_path__ + "static/img/fruits_orange.5f2982e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fruits_orange.png
// module id = Ngu7
// module chunks = 1